import { DataGrid, GridRowsProp, GridColDef, GridCellParams } from "@mui/x-data-grid";
import { useQuerySnapshot } from "../../services/use-allocation-api";
import { QuerySnapshotOptions, QuerySnapshotResponse } from "domains/allocations/services/allocation-service";
import localisations from "../../localisation";

type AllocationsTableProps = {
    partitionId: string;
    productFormatter?: ProductFormatter;
};

function GetRows(response: QuerySnapshotResponse) {
    let toReturn = response.items.map((item, index) => {
        return {
            id: index,
            ...item,
        };
    }) as GridRowsProp;

    return toReturn;
}

function GetColumns(productFormatter?: ProductFormatter) {
    let {
        columns: { product, quantity },
    } = localisations.currentAllocationsTable;

    let toReturn = [
        {
            field: "productId",
            headerName: product.headerName,
            description: product.description,
            sortable: false,
            filterable: false,
            flex: 0.5,
            renderCell: (params: GridCellParams) =>
                productFormatter ? productFormatter(params.value as number) : undefined,
        },
        {
            field: "quantity",
            headerName: quantity.headerName,
            description: quantity.description,
            sortable: false,
            filterable: false,
            flex: 0.5,
        },
    ] as GridColDef[];

    return toReturn;
}

function CurrentAllocations(props: AllocationsTableProps) {
    let options = { partitionId: props.partitionId } as QuerySnapshotOptions;
    const { loading, data } = useQuerySnapshot(options);

    return (
        <div style={{ height: 500, width: "100%" }}>
            {data && (
                <DataGrid
                    rows={GetRows(data)}
                    columns={GetColumns(props.productFormatter)}
                    loading={loading}
                    disableSelectionOnClick={true}
                />
            )}
        </div>
    );
}

export default CurrentAllocations;
